import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { parseApiDateTime } from '../../utils/datetime.utils';

const BRAZIL_TZ = 'America/Sao_Paulo';

@Pipe({ name: 'brDate' })
export class BrazilDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format = 'dd/MM/yyyy HH:mm'): string {
    if (value == null || value === '') return '—';

    if (value instanceof Date) {
      return formatDate(value, format, 'pt-BR', BRAZIL_TZ);
    }

    const raw = String(value).trim();
    if (!raw) return '—';

    const isDateTime = /[Hhms]/.test(format);
    if (!isDateTime) {
      const datePart = raw.split('T')[0];
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
      if (match) return `${match[3]}/${match[2]}/${match[1]}`;
    }

    const parsed = parseApiDateTime(raw);
    return parsed ? formatDate(parsed, format, 'pt-BR', BRAZIL_TZ) : raw;
  }
}
